import UserContainerGroup, { UserContainerGroupDTO } from 'models/container/UserContainerGroup';

export default class UserContainerService {
	toModel(container: UserContainerGroupDTO) {
		return new UserContainerGroup(container);
	}
}
